import { render, staticRenderFns } from "./AutoCompleteComp.vue?vue&type=template&id=038c1460&scoped=true"
import script from "./AutoCompleteComp.vue?vue&type=script&lang=js"
export * from "./AutoCompleteComp.vue?vue&type=script&lang=js"
import style0 from "./AutoCompleteComp.vue?vue&type=style&index=0&id=038c1460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c1460",
  null
  
)

export default component.exports